export function LogoMark({ className = "" }) {
  return (
    <svg viewBox="0 0 44 44" className={className} role="img" aria-label="Wirtualne biuro Warszawa — logo Twoje Biuro">
      <title>Wirtualne biuro Warszawa — Twoje Biuro</title>
      <path d="M0 10A10 10 0 0 1 10 0H20V10A10 10 0 0 1 10 20A10 10 0 0 1 0 10Z" fill="#E8503A" />
      <path d="M24 0H34A10 10 0 0 1 44 10A10 10 0 0 1 34 20A10 10 0 0 1 24 10Z" fill="#F2B21F" />
      <path d="M0 34A10 10 0 0 1 10 24A10 10 0 0 1 20 34V44H10A10 10 0 0 1 0 34Z" fill="#148F86" />
      <path d="M24 34A10 10 0 0 1 34 24A10 10 0 0 1 44 34A10 10 0 0 1 34 44H24Z" fill="#1B2432" className="dark:[fill:#E2E8F0]" />
    </svg>
  );
}

export default function Logo({ className = "h-9", showTagline = true }) {
  return (
    <span data-testid="brand-logo" title="Wirtualne biuro Warszawa — Twoje Biuro" className={`inline-flex items-center gap-3 ${className}`}>
      <LogoMark className="h-full w-auto shrink-0" />
      <span className="flex flex-col justify-center leading-none">
        <span className="font-display font-extrabold uppercase text-[1.25em] tracking-tight whitespace-nowrap">Twoje Biuro</span>
        {showTagline && (
          <span className="font-mono text-[0.42em] uppercase tracking-[0.3em] opacity-60 mt-1.5">
            Wirtualne biuro Warszawa · Księgowość
          </span>
        )}
      </span>
    </span>
  );
}
